module.exports = __webpack_public_path__ + "img/mammut_a763afddcf90fe61a9b115d5548c1dd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/mammut.jpg
// module id = 281
// module chunks = 0